$(document).ready(function(){
  $('.featured-collections__slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="38" height="61" viewBox="0 0 38 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="15.6997" height="4.07007" transform="matrix(-0.706792 0.707421 0.707421 0.706792 22.8926 19)" fill="white"/><rect width="15.6997" height="4.07007" transform="matrix(-0.706736 -0.707477 -0.707477 0.706736 25.7725 38.4416)" fill="white"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="39" height="61" viewBox="0 0 39 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="15.6521" y="19" width="15.6997" height="4.07007" transform="rotate(45.0255 15.6521 19)" fill="white"/><rect x="12.7725" y="38.4416" width="15.6997" height="4.07007" transform="rotate(-45.03 12.7725 38.4416)" fill="white"/></svg></div>',                                      
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".featured-collections__nav .nav-item").click(function(){
    var collection = $(this).data("collection");
    if(typeof collection != "undefined" && collection != ''){
      $(".featured-collections__nav .nav-item").removeClass("active");
      $(".featured-collections__slider").hide();
      $(this).addClass("active");
      $("#"+collection+"__slider.featured-collections__slider").show();
      $("#"+collection+"__slider.featured-collections__slider").slick("slickAdd");
    }
  });

  $(".mwtc--slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="38" height="61" viewBox="0 0 38 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="15.6997" height="4.07007" transform="matrix(-0.706792 0.707421 0.707421 0.706792 22.8926 19)" fill="white"/><rect width="15.6997" height="4.07007" transform="matrix(-0.706736 -0.707477 -0.707477 0.706736 25.7725 38.4416)" fill="white"/></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="39" height="61" viewBox="0 0 39 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="15.6521" y="19" width="15.6997" height="4.07007" transform="rotate(45.0255 15.6521 19)" fill="white"/><rect x="12.7725" y="38.4416" width="15.6997" height="4.07007" transform="rotate(-45.03 12.7725 38.4416)" fill="white"/></svg></div>'
  });
  $('.mwtc--slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.mwtc--dot').removeClass('active');
    var i = nextSlide + 1;
    $('.mwtc--dot[data-index='+i+']').addClass('active');
  });
  $('.mwtc--dot').click(function(){
    $('.mwtc--dot').removeClass('active');
    $(this).addClass('active');
    var i = $(this).data('index');
    $(".mwtc--slider").slick('slickGoTo', i-1);
  });
  $('.mwtc--slider').on('init', function(event, slick){
    if($(window).width() > 749){
      var maxHeight = 0;
      $('.mwtc--slider .slick-track .mwtc--slide').each(function() {
          var currentHeight = $(this).find('.mwtc--slide-content').innerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
      $(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", maxHeight);
    }
  });

  $(".product-media__slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.product-media__thumbs',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            dots: true,
            fade: true
          }
        }
      ]
  });
  $(".product-media__thumbs").slick({
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-media__slider',
    focusOnSelect: true,
    prevArrow: '<div class="arrow-left"><svg width="38" height="61" viewBox="0 0 38 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="15.6997" height="4.07007" transform="matrix(-0.706792 0.707421 0.707421 0.706792 22.8926 19)" fill="white"/><rect width="15.6997" height="4.07007" transform="matrix(-0.706736 -0.707477 -0.707477 0.706736 25.7725 38.4416)" fill="white"/></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="39" height="61" viewBox="0 0 39 61" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="15.6521" y="19" width="15.6997" height="4.07007" transform="rotate(45.0255 15.6521 19)" fill="white"/><rect x="12.7725" y="38.4416" width="15.6997" height="4.07007" transform="rotate(-45.03 12.7725 38.4416)" fill="white"/></svg></div>'
  });
  $(".product-media__thumb").click(function(){
    $(".product-media__thumb").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    $(".product-media__slider").slick('slickGoTo', i);
  });
  $(".product-media__slider").on("beforeChange", function(event, slick, currentSlide, nextSlide){
    $(".product-media__thumb").removeClass("active");
    $(".product-media__thumb[data-index='"+nextSlide+"']").addClass("active");
  });

  if($(window).width() < 750){
    $('.featured-blog__slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1
    });
    $(".article-template__related-products .product-list").slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1
    });
  }else{
    $('.featured-blog__slider').slick({
		rows: 2,
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
  }

  if($(window).width() < 990){
    $(".blog-posts__slider .blog__posts").slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
  }

  $('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

        callbacks: {
            open: function() {                        
                $('body').css('overflow', 'hidden'); 
            },                                       
            close: function() { 
                $('body').css('overflow', '');
            },
        }
  });

  $(".icon-with-text__video-close").click(function(){
    $(this).parent().find(".mfp-close").trigger("click");
  });

  $(".menu-drawer__header-close").click(function(){
    $("details[open] .header__icon--menu").trigger("click");
  });
  $(".menu-drawer__inner-submenu .icon-close").click(function(){
    $("details[open] .header__icon--menu").trigger("click");
  });

  var i = $(".featured-blog__slider").data("item");
  if($(window).width() < 750){
    i = i * 4;
  }else if($(window).width() >= 750 && $(window).width() < 990){
    i = i * 2;
  }
  $(".featured-blog__slider .slick-dots li").css("width", "calc(100%/"+i+")");

  $(".collection-hero__label").click(function(){
    $(this).parent().toggleClass("open");
    $(this).parent().find(".collection-hero__options").slideToggle();
  });

  $(".contact .field__checkbox").click(function(){
    if (!$(this).find("#agree-policy").is(":checked")) {
      $(this).find("#agree-policy").prop("checked", true);
    }else{
      $(this).find("#agree-policy").prop("checked", false);
    }
  });

  $('body').on('click', '.contact .contact__button .button', function() {
      if ($('#agree-policy').is(':checked')) {
        $(this).submit();
      }else {
        alert("You must agree with the privacy policy.");
        return false;
      }
  });

  $(".footer__back-to-top").click(function(){
    $('html, body').animate({
        scrollTop: 0
    }, '300');
  });

  $(".btn-quick-add").click(function(){
    $(this).parent().hide();
    var id = $(this).data("id");
    $("#quick-add__popup-"+id+".quick-add__popup").show();
    $("#quick-add__popup-"+id+".quick-add__popup").hover(function(){
    }, function(){
      $("#quick-add__popup-"+id+".quick-add__popup").hide();
    });
  });
  $(".quick-add__mobile").click(function(){
    var id = $(this).data("id");
    $("#quick-add__popup-"+id+".quick-add__popup").show();
    $("#quick-add__popup-"+id+".quick-add__popup").hover(function(){
    }, function(){
      $("#quick-add__popup-"+id+".quick-add__popup").hide();
    });
  });
  $(document).mouseup(function(e){
    var container = $(".quick-add__popup");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
    }

    var modal = $(".product-media-modal");
    if (!modal.is(e.target) && modal.has(e.target).length === 0) {
        $(".product-media-modal__toggle").trigger("click");
    }
  });
  $(".quick-add__atc").click(function(){
    var id = $(this).data("id");
    var option1 = $("#quick-add__popup-"+id+" .option-value-1").val();
    var option2 = $("#quick-add__popup-"+id+" .option-value-2").val();
    var option3 = $("#quick-add__popup-"+id+" .option-value-3").val();
    if(typeof option1 != "undefined" && typeof option2 === "undefined" && typeof option3 === "undefined"){
      var option = option1;
    }else if(typeof option1 != "undefined" && typeof option2 != "undefined" && typeof option3 === "undefined"){
      var option = option1+" / "+option2;
    }else if(typeof option1 != "undefined" && typeof option2 != "undefined" && typeof option3 != "undefined"){
      var option = option1+" / "+option2+" / "+option3;
    }
    var variant_id = '';
    $("#quick-add__popup-"+id+" .quick-add__popup-variants option").each(function(){
      var variant = $(this).text();
      if(variant == option){
        variant_id = $(this).data("variant-id");
      }
    });
    $("#quick-add__popup-"+id+" .quick-add__popup-variants").val(variant_id).trigger("change");
  });

  $(".quick-add__popup .option-select").click(function(){
    $(this).toggleClass("open");
    $(this).find(".option-select__dropdown").slideToggle();
  });

  $(".quick-add__popup .option-select__dropdown li").click(function(){
    var value = $(this).data("value");
    $(this).parents(".option-select").find(".option-select__active span").text(value);
    $(this).parents(".option-select").find("ul.option-select__dropdown li").show();
    $(this).hide();
    $(this).parents(".option-select").find(".option-value").val(value).trigger("change");
  });

  $(".collapsible-row-layout .accordion summary").click(function(){
    $(this).parent().toggleClass("open");
    $(this).parent().find(".accordion__content").slideToggle();
  });

  setTimeout(function(){
  $(".image-with-text__text-sticker").css("bottom", "0");
  }, 1000);

  if($(window).width() > 1440){
    var padding = (($(window).width() - 1410) / 2) + 45;
    $("#ImageWithText--template--22088497299737__image_with_text_pUMeNG").css("padding-left", padding);
    $(".mwtc--slide-content").css("padding-left", padding);
    $(".mwtc--dots").css("left", padding);
  }else if($(window).width() >= 990 && $(window).width() <= 1440){
    $("#ImageWithText--template--22088497299737__image_with_text_pUMeNG").css("padding-left", "7rem");
    $(".mwtc--slide-content").css("padding-left", "7rem");
    $(".mwtc--dots").css("left", "7rem");
  }

  if($(window).width() > 749){
    //$(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", $(window).width()/2);
    var maxHeight = 0;
    $('.mwtc--slider .mwtc--slide').each(function() {
        var currentHeight = $(this).find('.mwtc--slide-content').innerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });
    $(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", maxHeight);
  }else{
    $(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", $(window).width());
  }
});

$(window).resize(function(e) {
  if($(window).width() > 1440){
    var padding = (($(window).width() - 1410) / 2) + 45;
    $("#ImageWithText--template--22088497299737__image_with_text_pUMeNG").css("padding-left", padding);
    $(".mwtc--slide-content").css("padding-left", padding);
    $(".mwtc--dots").css("left", padding);
  }else if($(window).width() >= 990 && $(window).width() <= 1440){
    $("#ImageWithText--template--22088497299737__image_with_text_pUMeNG").css("padding-left", "7rem");
    $(".mwtc--slide-content").css("padding-left", "7rem");
    $(".mwtc--dots").css("left", "7rem");
  }

  $('.mwtc--slider').slick('slickAdd');
  if($(window).width() > 749){
    //$(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", $(window).width()/2);
    var maxHeight = 0;
    $('.mwtc--slider .slick-track .mwtc--slide').each(function() {
        var currentHeight = $(this).find('.mwtc--slide-content').innerHeight();
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }
    });
    $(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", maxHeight);
  }else{
    $(".media-with-text-carousel .mwtc--slide-image img, .media-with-text-carousel .mwtc--slide-image video").css("height", $(window).width());
  }
});

$(document).mouseup(function(e) {
  var container = $(".collection-hero__filter");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    if(container.hasClass("open")){
      container.find(".collection-hero__label").trigger("click");
    }
  }
});

$(function(){
  if(typeof $.session.get('data-scheme') != 'undefined'){
    $("html").attr("data-scheme", $.session.get('data-scheme'));
  }else{
    $("html").attr("data-scheme", "dark");
  }
  setTimeout(function(){
    $(".header__toggle-scheme-item svg").css("visibility", "visible");
  }, 1);
  // $(".header__toggle-scheme .icon-light-mode").click(function(){
  //   $("html").attr("data-scheme", "light");
  //   $.session.set('data-scheme', 'light');
  // });
  // $(".header__toggle-scheme .icon-dark-mode").click(function(){
  //   $("html").attr("data-scheme", "dark");
  //   $.session.set('data-scheme', 'dark');
  // });
  $(".header__toggle-scheme-item--light").click(function(){
    $(this).removeClass("active");
    $(".header__toggle-scheme-item--dark").addClass("active");
    $("html").attr("data-scheme", "dark");
    $.session.set('data-scheme', 'dark');
  });
  $(".header__toggle-scheme-item--dark").click(function(){
    $(this).removeClass("active");
    $(".header__toggle-scheme-item--light").addClass("active");
    $("html").attr("data-scheme", "light");
    $.session.set('data-scheme', 'light');
  });
  
  // $('.instafeed__marquee-left').liMarquee({
  //           direction: 'left',
		// 	loop:-1,			
		// 	scrolldelay: 0,		
		// 	scrollamount:30,	
		// 	circular: true,	
  //           hoverstop:false,
		// 	drag: true			
		// });
  //   $('.instafeed__marquee-right').liMarquee({
  //           direction: 'right',
		// 	loop:-1,			
		// 	scrolldelay: 0,		
		// 	scrollamount:10,	
		// 	circular: true,	
  //           hoverstop:false,
		// 	drag: true			
		// });

  $("body").on('DOMSubtreeModified', function(){
    if($(this).hasClass('rebuy-modal-visible')){
    }else{
      $(this).removeClass('overflow-hidden');
    }
  });

  document.addEventListener('rebuy:cart.change', (event) => { 
    $(".cart-count-bubble").text(event.detail.cart.cart.item_count);
  });
});




/************************************************************************************

* [POLICIES PAGE]: SMOOTH SCROLLING / ONE TRUST TRIGGER MODAL

*************************************************************************************/
document.addEventListener('DOMContentLoaded', function () {
  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]')
  const oneTrustTriggerLinks = document.querySelectorAll('a.ontrust-trigger')
  console.log(oneTrustTriggerLinks);


  smoothScrollLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      const targetId = this.getAttribute('href').substring(1)
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  })

  oneTrustTriggerLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()

      console.log(OneTrust);

      if (OneTrust && OneTrust.ToggleInfoDisplay) {
        OneTrust.ToggleInfoDisplay()
      }
    })
  })
})